<section role="region" class="not-found">
  <div class="not-found__center">
    <img src="/assets/images/404.svg" alt="Page non trouvée" class="not-found__image" />

    <div class="not-found__buttons">
      <a class="not-found__buttons__button" [routerLink]="['/']">Accueil</a>
      <button type="button" class="not-found__buttons__back btn-clean" (click)="back()">Retour</button>
    </div>
  </div>
</section>
